/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Chart_Reset_ZoomInputs */

const en_ui_chart_reset_zoom = /** @type {(inputs: Ui_Chart_Reset_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset zoom`)
};

const de_ui_chart_reset_zoom = /** @type {(inputs: Ui_Chart_Reset_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset zoom" |
*
* @param {Ui_Chart_Reset_ZoomInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_chart_reset_zoom = /** @type {((inputs?: Ui_Chart_Reset_ZoomInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Chart_Reset_ZoomInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_chart_reset_zoom(inputs)
	return de_ui_chart_reset_zoom(inputs)
});